import { StyleSheet } from 'aphrodite';
import { white } from '../../../../styles/colors';

/**
 * Styles for ContactFlowVisualizer component.
 * Handles the animation and display of contacts moving along automation flow edges.
 */
export const styleSheet = StyleSheet.create({
	svgContainer: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		pointerEvents: 'none',
		overflow: 'visible',
		zIndex: 1000,
	},

	foreignObject: {
		overflow: 'visible',
	},

	contactAvatar: {
		width: 36,
		height: 36,
		borderRadius: '50%',
		border: `3px solid ${white}`,
		boxShadow: '0 2px 12px rgba(0, 0, 0, 0.25)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		cursor: 'pointer',
		fontFamily: 'system-ui, -apple-system, sans-serif',
		animationName: {
			'0%': { transform: 'scale(1)' },
			'50%': { transform: 'scale(1.05)' },
			'100%': { transform: 'scale(1)' },
		},
		animationDuration: '2s',
		animationIterationCount: 'infinite',
	},

	contactInitials: {
		fontSize: 13,
		fontWeight: 700,
		color: white,
		userSelect: 'none',
		textShadow: '0 1px 3px rgba(0, 0, 0, 0.4)',
	},
});

// Backwards compatible alias
export const contactFlowVisualizerStyles = styleSheet;
